import { MaskedLine, FadeIn, SectionHead } from "./Shared";

const CHAPTERS = [
  {
    num: "01",
    title: "Visual Intensity",
    body: "Every frame is crafted like a film still. No filler, no generic coverage — compositions built with intent, light treated as the subject.",
  },
  {
    num: "02",
    title: "Uncompromising Grade",
    body: "Color graded for the metallic sheen of speed and the warmth of luxury lighting. The image you get looks like the memory felt.",
  },
  {
    num: "03",
    title: "Accessible Elite",
    body: "Cinema-grade production brought within reach. High-value video and photography for creators, owners and businesses — at an accessible cost.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-16 md:py-24" data-testid="manifesto-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <SectionHead index="01" kicker="Manifesto" title="Built on" accent="Intent" />
        <div>
          {CHAPTERS.map((c, i) => (
            <FadeIn key={c.num} delay={i * 0.05}>
              <div className="group border-t border-white/10 py-10 md:py-14 grid grid-cols-12 gap-6 items-start hover:bg-white/[0.02] transition-colors duration-300 px-2 md:px-4">
                <div className="col-span-3 md:col-span-2">
                  <span className="font-serifaccent italic font-light text-5xl md:text-7xl text-gold/80 group-hover:text-gold transition-colors duration-300">
                    {c.num}
                  </span>
                </div>
                <div className="col-span-9 md:col-span-4">
                  <MaskedLine>
                    <h3 className="font-display text-2xl md:text-4xl font-bold uppercase tracking-tight">
                      {c.title}
                    </h3>
                  </MaskedLine>
                </div>
                <div className="col-span-12 md:col-span-6 md:col-start-7">
                  <FadeIn delay={0.15}>
                    <p className="text-sm md:text-base text-zinc-400 leading-relaxed max-w-xl">{c.body}</p>
                  </FadeIn>
                </div>
              </div>
            </FadeIn>
          ))}
          <div className="border-t border-white/10" />
        </div>
      </div>
    </section>
  );
}
